import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Privacy Policy</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <div className="space-y-4 text-sm">
            <div>
              <p className="font-semibold text-gray-900">L.H. Cinq-continent Inc.</p>
              <p className="text-gray-600">NEQ: 2264343056</p>
              <p className="text-gray-600">Effective Date: March 28, 2026</p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">1. Data Collection & Purpose</h3>
              <p className="text-gray-700 mb-2">
                In compliance with Quebec's Law 25 and Canada's PIPEDA, we collect guest information (Name, Email, Phone, and Identity Verification) solely to:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-gray-700">
                <li>Securely grant access to our high-speed network.</li>
                <li>Validate identity for insurance claims and building security.</li>
                <li>Provide exclusive discounts for our partner services (Yachting, Car Rental, Dining).</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">2. Data Protection</h3>
              <p className="text-gray-700">
                Your personal information is encrypted and stored on secure servers. We strictly <strong>DO NOT sell or trade</strong> your personal data to third-party marketing firms.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">3. Your Rights</h3>
              <p className="text-gray-700">
                You have the right to access, correct, or request the deletion of your personal data at any time. For privacy inquiries, please contact our data officer at:{' '}
                <a href="mailto:info@send.homesbyli.com" className="text-blue-600 hover:underline">
                  info@send.homesbyli.com
                </a>
                .
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg text-gray-900 mb-2">4. Consent</h3>
              <p className="text-gray-700">
                By connecting to our Wi-Fi or booking through Homesbyli, you consent to the collection and use of your information as outlined in this policy.
              </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6">
              <p className="text-sm text-blue-900">
                <strong>Contact Information:</strong><br />
                L.H. Cinq-continent Inc.<br />
                Email: <a href="mailto:info@send.homesbyli.com" className="text-blue-600 hover:underline">info@send.homesbyli.com</a>
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyPolicyModal;
